import React, { Component } from 'react'
import { asyncConnect } from 'redux-async-connect'
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
import Helmet from 'react-helmet'
import config from '../../config'
import {
  HeaderMenu,
  // DonateModal,
  Footer,
  AppDisclaimer,
  LeadCaptureFormManager,
} from '../../components'
import { setTimeExpired } from 'redux/modules/timer'
import { incrementPageCount } from 'redux/modules/pageCount'
import Styles from './App.css'

@asyncConnect([{
  promise: ({store: {dispatch, getState}}) => {
    return Promise.resolve()
  }
}])
@connect(
  null,
  { setTimeExpired, incrementPageCount }
)
@CSSModules(Styles, {allowMultiple:true})
export default class App extends Component {
  constructor(props) {
    super(props)
  }
  componentDidMount() {
    this.unlisten = this.props.history.listen(() => {
      this.props.incrementPageCount();
    });

    this.timer = setTimeout(() => {
      this.props.setTimeExpired();
    }, 5 * 60 * 1000); // 0.05 * 60 * 1000 = 3 seconds
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
    this.unlisten();
  }

  render() {
    config.app.head.meta = config.app.head.meta.map(( meta ) =>{
      // since config.js doesnt have access to import, we will inject the image path here
      // after a replacement of the absolute url with
      if( meta.property === 'og:image' || meta.property === 'twitter:image'){
        meta.content = config.domain+'../../../static/images/'+config.imageSocialShare.replace(/.*dist/,'/dist')
      }
      return meta
    })
    //
    return (
      <div styleName='main'>
        <LeadCaptureFormManager />
        <div id='anchor-top'/>
        <Helmet {...config.app.head}/>
        <HeaderMenu />
        { /* <DonateModal /> */ }
        <div styleName='content'>
          {this.props.children}
        </div>
        <Footer/>
        <AppDisclaimer />
      </div>
    )
  }
}

